import AuthTypeChoice from "./AuthTypeChoice";

const CadastroChoice = () => <AuthTypeChoice mode="signup" />;

export default CadastroChoice;
